import { render, staticRenderFns } from "./store-message.vue?vue&type=template&id=d0c9be92&scoped=true&"
import script from "./store-message.vue?vue&type=script&lang=js&"
export * from "./store-message.vue?vue&type=script&lang=js&"
import style0 from "./store-message.vue?vue&type=style&index=0&id=d0c9be92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c9be92",
  null
  
)

export default component.exports